import { CurrencyPipe } from '@angular/common';

export const checkChar = (e: KeyboardEvent): boolean => {
    if (e.key === 'e') {
        return false;
    }
    return true;
};

export const formatAndAssignCurrencyValue = (event: Event, currencyPipe: CurrencyPipe): boolean => {
    const formattedValue = currencyPipe.transform((event.target as HTMLInputElement).value, '', '', '1.1-2');
    if (formattedValue) {
        (event.target as HTMLInputElement).value = formattedValue.replaceAll(',', '');
    }

    return true;
};
